import React from 'react';
import Alert from 'react-s-alert';
import { DocumentStateListTask } from './document-state-list/DocumentStateListTask';

export class OutsourceListLegend extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            states: [],
        };
    }

    componentDidMount() {
        this.listDocumentStates();
    }

    render() {
        const { states } = this.state;

        return (
            <div className="chart-key">
                {
                    states.map((state) => {
                        const { id, name, color } = state;
                        const style = { backgroundColor: `#${color}` };
                        return (
                            <span key={id}><span className="badge-state" style={style}/>{name}</span>
                        );
                    })
                }
            </div>
        );
    }

    listDocumentStates = () => {
        new DocumentStateListTask()
            .onSuccess((res) => this.setState({ states: res.data }))
            .onFail((error) => Alert.error(error))
            .execute();
    };
}

OutsourceListLegend.propTypes = {};

OutsourceListLegend.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/outsource/list/OutsourceListLegend.jsx